// extracted by mini-css-extract-plugin
module.exports =  {"mpi-brief":"ucOKwuj","mpiBrief":"ucOKwuj","blurred-list-img":"_UulTGk","blurredListImg":"_UulTGk"};